import { render, staticRenderFns } from "./RunnersTable.vue?vue&type=template&id=436c2e55&scoped=true&"
import script from "./RunnersTable.vue?vue&type=script&lang=js&"
export * from "./RunnersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c2e55",
  null
  
)

export default component.exports